
import { Component, Prop, Vue } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmIcon } from "@afe/amui/src/components/Icon";

@Component({
  components: {
    AmTypography,
    AmIcon
  }
})
export default class extends Vue {
  @Prop(String) readonly message!: string;

  onCallMe(e: any) {
    e.preventDefault();
    if (e.target.closest(".reset-password-call-me")) {
      this.$emit("callMe");
    }
  }
}
